export const visit = (vm, at) => {
vm(require("commerce-contract-lib/lang/en.lyaml"));
vm(require("ExportDialog/lang/en.lyaml"));
vm(require("crm-links/lang/en.lyaml"));
vm(require("multi-account-crm-panel-lib/lang/en.lyaml"));
vm(require("crm-activity-creator-widgets/lang/en.lyaml"));
vm(require("card-preview-highlight-lib/lang/en.lyaml"));
vm(require("ui-business-units-lib/lang/en.lyaml"));
vm(require("BizOpsCrmUIComponents/lang/en.lyaml"));
vm(require("customer-data-objects-ui-components/lang/en.lyaml"));
vm(require("customer-data-properties/lang/en.lyaml"));
vm(require("portal-alert-banners-lib/lang/en.lyaml"));
at({ "en": { "ObjectHighlightCard": { "placeholderText": "Object Highlight Card", "settingsButtonLabel": "Settings", "actionsDropdownLabel": "Actions", "miniCreateActivitiesButtonLabel": "Create activities" } } });
};